// extracted by mini-css-extract-plugin
export var carrierIcon = "_vd-0";
export var carrierLogo = "_vd-1";
export var detailsSection = "_vd-2";